import React, { useEffect, useState } from "react";
import Navbars from "../Navbars";
import Sidebar from "./Sidebar";
import down from "../assets/down.png";
import img from "../assets/img.png";
import Dashboardfooter from "./Dashboardfooter";
import cross from "../assets/cross.png";
import Selectcustom from "../Info/Selectcustom";
import Selectcustoms from "../Info/Selectcustoms";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Directories from "./Directories";
function Dashboard() {

  const routeParams = useParams();
  const listingData = useSelector((state) => state.getBusiness.data);

  const [previewData, setPreviewData] = useState({});
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [street, setStreet] = useState("");
  const [city1, setCity1] = useState("");
  const [city2, setCity2] = useState("");
  const [state, setState] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [discription, setDiscription] = useState("");
  const [zip, setZip] = useState("");


  useEffect(() => {
    let data=listingData.filter((val)=>{
        if(val.id==routeParams.id)
        return val
    })
    setPreviewData(data[0])
    setName(data[0].business_name);
    // setAddress(data[0].business_name);
    setStreet(data[0].street_name);
    setCity1(data[0].city1);
    setCity2(data[0].city2);
    setState(data[0].state);
    setPhone(data[0].phone_number);
    setEmail(data[0].email);
    setWebsite(data[0].website);
    setDiscription(data[0].business_description);
    setZip(data[0].city_zip);
    console.log("data",data)
  }, [listingData]);

  
  

  return (
    <>
      <div className="conatiner-fluid" style={{ backgroundColor: "#F5F5F5" }}>
        <Navbars />
        {/* <button className='ad_btn mt-2 show_btn' onClick={buttonPress}>Menu</button> */}
        <div className="d-flex gap-5 pe-3 main_div">
          <Sidebar />
          <div className="main_grid pt-3">
            <div className="inner_div  ps-3 pe-3 mb-5 pb-5">
              <div className="d-flex justify-content-between gap-3 pt-4 flex-wrap ">
                <p className="adx_no">
                  Cube ADX - #00019298812
                </p>
                <div className="d-flex gap-1">
                  <p className="balance">Your Balance:</p>
                  <p>$1000.00</p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label">1- Business Name</p>
                  <input className="input1" placeholder="Cube Adx" value={name}/>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="w-100">
                    <p className="label">2- Business Category</p>
                    <div style={{ position: "relative", maxWidth: "600px" }}>
                      <Selectcustom
                        className="input2 w-100"
                        placeholder={"Message Services"}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "10px",
                        }}
                      >
                        <img src={down} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="label">3- Address</p>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">Street Number / Name</p>
                  <input className="input1 w-100" placeholder="106 Douers" value={street} />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <p className="label1">State</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={state} />
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <p className="label1">City</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={city1} />
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <p className="label1">City Zip</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={zip} />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">4- Phone Number</p>
                  <input className="input1 w-100" placeholder="106 Douers" value={phone} />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <p className="label2">
                    6-Upload up to 5 images{" "}
                    <span>
                      {" "}
                      (size must be (950px X 720px) and (1900px X 1440px) Each)
                    </span>{" "}
                  </p>
                  <button className="upload_btn">Upload Files</button>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <p className="label2">Upload a Video </p>
                  <button className="upload_btn" style={{ marginTop: "33px" }}>
                    Upload Files
                  </button>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <p className="label2">
                    Upload Logo image <br></br>
                    <span>(400px X 400 px) </span>{" "}
                  </p>
                  <button className="upload_btn" style={{ marginTop: "10px" }}>
                    Upload Files
                  </button>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">5- Business Email</p>
                  <input
                    className="input1 w-100"
                    placeholder="info@cubeadx.com"
                    value={email}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mt-1 ">
                  <div className="d-flex gap-1 flex-wrap">
                    <img src={img} />
                    <img src={img} />
                    <img src={img} />
                    <img src={img} />
                    {/* <img src={img}/> */}
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <img src={img} />
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <img src={img} />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">
                    7- Add up to 10 key words
                    <span className="span_txt">
                      {" "}
                      ( Max 30 letters/keyword){" "}
                    </span>
                  </p>
                  <div className="input1 ps-2 pe-2 pb-2">
                    <div className="d-flex gap-1 flex-wrap">
                      <div className="badge_main">
                        <p>Los Angeles</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Business</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Mesa</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Mesa</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <div className="d-flex gap-1 flex-wrap">
                    <p className="label1">
                      8- Add extra City{" "}
                      <span className="span_txt">
                        {" "}
                        (you can choose different Cities){" "}
                      </span>
                    </p>
                    <div className="d-flex gap-1">
                      {/* <Selectcustom placeholder={"City - 1"}/> */}
                      <div style={{ position: "relative", maxWidth: "600px" }}>
                        <input
                          className="input1 w-100"
                          placeholder="City - 1"
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                          }}
                        >
                          <img src={down} />
                        </div>
                      </div>
                      <div style={{ position: "relative", maxWidth: "600px" }}>
                        <input
                          className="input1 w-100"
                          placeholder="City - 2"
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                          }}
                        >
                          <img src={down} />
                        </div>
                      </div>
                    </div>
                    <div className="input1 ps-2 pe-2 pb-2 mt-2">
                      <div className="d-flex gap-1 flex-wrap">
                        <div className="badge_main">
                          <p>Los Angeles</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Business</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Mesa</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Mesa</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">Business Website</p>
                  <input className="input1" placeholder="www.cubeadx.com" />
                </div>
              </div>
              <div>
              <div className='row mt-2'>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>9- Business working days and hours</p>
        {state.map((value, index) => {
          return (
            <div className='d-flex align-items-center justify-content-between' style={{ overflow: 'hidden' }} key={index}>
              <div className='day_div'>
                <p className='day'>{value.day}</p>
                <div >
                  <p className='status'>{value.status1}</p>
                  <p className='status1'>{value.status2}</p>
                </div>

              </div>
              <div className='d-flex align-items-center justify-content-between seconed_main'>
                <div className='day2_div'>
                  <div>
                    <p className='times'>{value.time}</p>
                    <div className='hour_div'>
                      <p>00:00</p>
                    </div>
                  </div>

                  <div >
                    <p className='mode'>{value.mode1}</p>
                    <p className='mode1'>{value.mode2}</p>
                  </div>
                </div>
                <p className='mt-4'>-</p>
                <div className='day2_div'>
                  <p className='times'>{value.time2}</p>
                  <div >
                    <p className='mode'>{value.mode1}</p>
                    <p className='mode1'>{value.mode2}</p>
                  </div>
                </div>
              </div>
            </div>)
        })}
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>10- Business Description</p>
        <div style={{ position: "relative" }}>
          <textarea className='textarea' placeholder='Description...'>
          </textarea>
          <p className='numbering'>10<span className='text'>/750</span></p>
        </div>
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12 mt-3'>
        <Directories/>
      </div>
    </div>
    <div className='d-flex justify-content-center mt-5'>
      <button className='update_btn'>Update</button>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
